import { gql } from '@apollo/client'

export const GET_RAW_MATERIALS = gql`
  query GetRawMaterials($filters: RawMaterialFilters) {
    rawMaterials(filters: $filters) {
      id
      name
      unit
      type
      notes
      active
      track_inventory
      current_cost_per_unit_millicents
      cost_per_unit_millicents
    }
  }
`

export const GET_RAW_MATERIAL = gql`
  query GetRawMaterial($id: Int!) {
    rawMaterial(id: $id) {
      id
      name
      unit
      type
      output_quantity
      notes
      active
      track_inventory
      current_cost_per_unit_millicents
      cost_per_unit_millicents
    }
  }
`

export const GET_RECIPE_INGREDIENTS = gql`
  query GetRecipeIngredients($parentId: Int!) {
    recipeIngredients(parentId: $parentId) {
      id
      parent_id
      child_id
      quantity
      child {
        id
        name
        unit
        type
      }
    }
  }
`

export const GET_RAW_MATERIAL_PRICE_HISTORY = gql`
  query GetRawMaterialPriceHistory($rawMaterialId: Int!) {
    rawMaterialPriceHistory(rawMaterialId: $rawMaterialId) {
      id
      cost_per_unit_millicents
      effective_from
      created_at
    }
  }
`

export const GET_VARIANT_INGREDIENTS = gql`
  query GetVariantIngredients($variantId: Int!) {
    variantIngredients(variantId: $variantId) {
      id
      raw_material_id
      quantity
    }
  }
`

export const GET_OPTION_ITEM_INGREDIENTS = gql`
  query GetOptionItemIngredients($optionItemId: Int!) {
    optionItemIngredients(optionItemId: $optionItemId) {
      id
      variant_id
      raw_material_id
      quantity
      raw_material { id name unit }
      variant { id name product { id name } }
    }
  }
`

export const CALCULATE_COGS = gql`
  query CalculateCogs($variantId: Int!, $selectedOptionItemIds: [Int!]) {
    calculateCogs(variantId: $variantId, selectedOptionItemIds: $selectedOptionItemIds) {
      variant_cogs_millicents
      option_cogs_millicents
      total_cogs_millicents
      total_cogs_cents
    }
  }
`

export const GET_VARIANT_OPTION_ITEM_PRICING = gql`
  query VariantOptionItemPricing($productId: Int!) {
    variantOptionItemPricing(productId: $productId) {
      product_name
      variants { id name price_cents }
      option_items { id label }
      rows {
        id
        option_item_id
        option_item_label
        variant_id
        variant_name
        raw_material_name
        raw_material_unit
        quantity
        cost_millicents
      }
    }
  }
`

export const GET_VARIANT_OPTIONS_FOR_MATRIX = gql`
  query GetVariantOptionsForMatrix($variantId: Int!) {
    variantOptionGroupsByVariant(productVariantId: $variantId) {
      option_group_id
      name
      min_select
      max_select
      option_items {
        id
        label
        price_delta_cents
        planning_relevant
      }
    }
  }
`

export const BUNDLE_MARGIN_MATRICES = gql`
  query BundleMarginMatrices {
    bundleMarginMatrices {
      bundle_product_id
      bundle_product_name
      bundle_variants {
        id
        name
        price_cents
      }
      groups {
        bundle_group_id
        name
        is_main
        required_count
        options {
          bundle_group_option_id
          eligible_variant_id
          eligible_variant_name
          eligible_product_name
          price_delta_cents
          cogs_millicents
          cogs_cents
        }
      }
      combinations {
        selected_option_ids
        total_price_delta_cents
        total_cogs_millicents
        total_cogs_cents
        upgrade_margin_pct
      }
    }
  }
`

export const BUNDLE_MARGIN_MATRIX = gql`
  query BundleMarginMatrix($bundleProductId: Int!) {
    bundleMarginMatrix(bundleProductId: $bundleProductId) {
      bundle_product_id
      bundle_product_name
      bundle_variants {
        id
        name
        price_cents
      }
      groups {
        bundle_group_id
        name
        is_main
        required_count
        options {
          bundle_group_option_id
          eligible_variant_name
          price_delta_cents
          cogs_millicents
          cogs_cents
        }
      }
      combinations {
        label
        selected_option_ids
        total_price_delta_cents
        total_cogs_millicents
        total_cogs_cents
        upgrade_margin_pct
      }
    }
  }
`
